var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "Análisis";
var Blockchain = "Cadena de bloque";
var Compliance = "Cumplimiento";
var Compute = "Computación";
var Containers = "Contenedores";
var Databases = "Bases de datos";
var Games = "Games";
var Migration = "Migración";
var Mobile = "Móvil";
var Networking = "Redes";
var Robotics = "Robótica";
var Satellite = "Satélite";
var Security = "Seguridad";
var Serverless = "Sin servidor";
var Storage = "Storage (Almacenamiento)";
var WebApps = "WebApps";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "Artifact";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "Copia de seguridad";
var Batch = "Batch";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "Budgets";
var Chatbot = "Chatbot";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Config";
var Connect = "Conectarse";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dash";
var DataSync = "DataSync";
var DataZone = "DataZone";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "Detectora";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "Salud";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "Uno";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Organizations";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "Personalize";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "QuickSight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RoboMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "Migración de VMware";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C#",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "Integración de aplicaciones",
	"AR/VR": "AR/VR",
	"Architecture Strategy": "Estrategia de arquitectura",
	"Artificial Intelligence": "Inteligencia artificial",
	Blockchain: Blockchain,
	"Business applications": "Business Applications (Aplicaciones empresariales)",
	"Cloud Financial Management": "Administración financiera en la nube",
	"Cloud Foundations": "Fundamentos de la nube",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "Centro de contacto",
	Containers: Containers,
	"Data Integration": "Integración de datos",
	Databases: Databases,
	"Developer Tools": "Herramientas para desarrolladores",
	"End-User Computing (EUC)": "Computación para el usuario final (EUC)",
	"Front-End Development": "Desarrollo de front-end",
	Games: Games,
	"Generative AI": "IA generativa",
	"High Performance Computing (HPC)": "Informática de alto rendimiento (HPC)",
	"Identity Management": "Administración de identidades",
	"Machine Learning": "Machine Learning",
	"Machine Learning & AI": "Machine Learning e IA",
	"Management & Governance": "Administración y gobernanza",
	"Media services": "Servicios multimedia",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "Redes y entrega de contenido",
	"Quantum Technologies": "Tecnologías cuánticas",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "Seguridad, identidad y conformidad",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "API Gateway",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "APP Config",
	"App Mesh": "App Mesh",
	"App Runner": "App Runner",
	"App Studio": "App Studio",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Application Discovery Service",
	"Application Migration Service": "Application Migration Service",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Audit Manager",
	Aurora: Aurora,
	"Auto Scaling": "Auto Scaling",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "Billing Conductor",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Certificate Manager",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Sala limpia",
	"Cloud Control API": "API de control en la nube",
	"Cloud Development Kit (CDK)": "Cloud Development Kit (CDK)",
	"Cloud Directory": "Cloud Directory",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "WAN en la nube",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "Compute Optimizer",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Cost Explorer",
	Dash: Dash,
	"Data Exchange": "Intercambio de datos",
	"Data Pipeline": "Data Pipeline",
	"Database Migration Service (DMS)": "Database Migration Service (DMS)",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "Aprendizaje profundo",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Directory Service",
	"Distro for OpenTelemetry": "Distro para OpenTelemetry",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Elastic Block Storage (EBS)",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute (EC2)",
	"Elastic Container Registry (ECR)": "Elastic Container Registry (ECR)",
	"Elastic Container Service (ECS)": "Elastic Container Service (ECS)",
	"Elastic Disaster Recovery (DRS)": "Elastic Disaster Recovery (DRS)",
	"Elastic File System (EFS)": "Elastic File System (EFS)",
	"Elastic Inference": "Elastic Inference",
	"Elastic Kubernetes Service (EKS)": "Elastic Kubernetes Service (EKS)",
	"Elastic Transcoder": "Elastic Transcoder",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "Fault Injection Simulator",
	"File Cache": "Caché de archivos",
	FinSpace: FinSpace,
	"Firewall Manager": "Firewall Manager",
	Forecast: Forecast,
	"Fraud Detector": "Fraud Detector",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Global Accelerator",
	Glue: Glue,
	"Ground Station": "Ground Station",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "IAM Identity Center",
	"Identity and Access Management (IAM)": "Identity and Access Management (IAM)",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Interactive Video Service",
	"Internet of Things (IoT)": "Internet de las cosas (IoT)",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Key Management Service (KMS)",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Launch Wizard",
	Lex: Lex,
	"License Manager": "License Manager",
	Lightsail: Lightsail,
	"Local Zones": "Zonas locales",
	"Location Service": "Location Service",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "Mainframe Modernization",
	"Managed Blockchain": "Blockchain administrado",
	"Managed Grafana": "Managed Grafana",
	Monitron: Monitron,
	"MQ Message Broker": "Agente de mensajes de MQ",
	Neptune: Neptune,
	"Network Firewall": "Network Firewall",
	Neuron: Neuron,
	"Nimble Studio": "Nimble Studio",
	One: One,
	"OpenSearch Service (OSS)": "OpenSearch Service (OSS)",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "Private 5G",
	"Private Certificate Authority": "Private Certificate Authority",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "P ",
	"Quantum Solutions Lab": "Laboratorio de soluciones cuánticas",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "Relational Database Service (RDS)",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost Private",
	"Resilience Hub": "Resilience Hub",
	"Resource Access Manager": "Resource Access Manager",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Secrets Manager",
	"Security Hub": "Security Hub",
	"Security Lake": "Security Lake",
	"Server Migration Service (SMS)": "Server Migration Service (SMS)",
	"Serverless Application Repository": "Repositorio de aplicaciones sin servidor",
	"Service Catalog": "Service Catalog",
	"Service Management Connector": "Conector de administración de servicios",
	Shield: Shield,
	"Simple Email Service (SES)": "Simple Email Service (SES)",
	"Simple Notification Service (SNS)": "Simple Notification Service (SNS)",
	"Simple Queue Service (SQS)": "Simple Queue Service (SQS)",
	"Simple Storage Service (S3)": "Simple Storage Service (S3)",
	"Simspace Weaver": "Simspace Weaver",
	"Single Sign-On (SSO)": "Inicio de sesión único (SSO)",
	"Snow Family": "Snow Family",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Step Functions",
	"Storage Gateway": "Storage Gateway",
	Sumerian: Sumerian,
	"Supply Chain": "Cadena de suministros",
	"Systems Manager": "Systems Manager",
	"Telco Network Builder": "Telco Network Builder",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "Acceso verificado",
	"Verified Permissions": "Verified Permissions",
	"Virtual Private Cloud (VPC)": "Virtual Private Cloud (VPC)",
	"Virtual Private Network (VPN)": "Red privada virtual (VPN)",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "Firewall para aplicaciones web (WAF)",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
